module.exports = __webpack_public_path__ + "static/media/error.9cfbe54d.png";